module.exports = __webpack_public_path__ + "img/sealog-logo.8df93f02.png";